
import { IPassengerGroup, IPassengerGroupPassenger } from '@/typings/timit';
import { Vue, Prop, Component } from 'vue-property-decorator';
import vuetifyToast from "vuetify-toast";

@Component
export default class RemovePassengerFromGroupConfirmationDialog extends Vue{
  @Prop({ default: false }) open: boolean;
  @Prop({ default: null }) passenger: IPassengerGroupPassenger | null;
  @Prop({ default: null }) passengerGroup: IPassengerGroup | null

  async removePassengerFromGroup() {
    try {
      const result = await this.$store.dispatch(
        "organization/removePassengerFromPassengerGroup", {
          params: { id: this.passengerGroup.id, passengerId: this.passenger.id },
        }
      );
      vuetifyToast.success(this.$i18n.translate("organization.passengerGroup.removeSuccess", "Passenger was successfully removed from passenger group."));
      this.$emit('remove', this.passenger)
    } catch (error) {
      vuetifyToast.error(this.$i18n.translate("organization.passengerGroup.removeError", "Something went wrong while removing passenger from passenger group"));
    }
  }

  close() {
    this.$emit('close');
  }
}
